export class Source{
    uniqueId:string
    sourcename:string
}